import React, { useEffect, useState } from 'react';
import styles from '../styles';
import {
  RBHBox,
  RBHImage,
  RBHTable,
  RBHText,
  RBHTextInput,
  RBHButton,
  RBHAlert,
  RBHSteps
} from '../../../../../../shared/components';
import { Breadcrumb, Empty, Form, Space, Steps } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import styleText from '../../../../../../shared/components/rbh-text/styles';
import { mainCreators } from '../../../../../main-action';
import { MAIN_STATE_KEY } from '../../../../../main-reducer';
import metrics from '../../../../../../shared/theme/metrics';
import { Fonts, Images } from '../../../../../../shared/theme';
import { httpCreators, MenuValidator, useLoadingSelector } from 'rbh-merchant-core';
import './styles.css';
import { generalCreators } from '../../../../../../redux/general/general-action';
import { GENERAL_STATE_KEY } from '../../../../../../redux/general/general-reducer';
import { MODAL_TYPE } from '../../../../../../redux/general/general-constant';
import { POS_STATE_KEY, posStateSelector } from '../../redux/pos-reducer';
import { posCreators } from '../../redux/pos-action';
import { BUTTON_FLAG, POS_REQUEST_ID_LIST } from '../../redux/pos-constant';
import { posSagas } from '../../redux/pos-saga';
import { PosService } from '../../redux/pos-service';
import { Branch } from '../../../../../../shared/models/branch';

export const PosStep1Screen: React.FC<Props> = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const history = useHistory();
  const loading = useLoadingSelector(POS_REQUEST_ID_LIST.GET_POS_FOOD_MENU);
  const shopData = useSelector(posStateSelector(POS_STATE_KEY.POS_SHOP_DATA)) as Branch;
  const foodMenuData = useSelector(posStateSelector(POS_STATE_KEY.POS_FOOD_MENU)) as [];
  const alertSuccess = useSelector(posStateSelector(POS_STATE_KEY.ALERT_SUCCESS));
  const [formInvalid, setFormInvalid] = useState(true);

  useEffect(() => {
    dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 1));
    if (!shopData) {
      toPath('/main/posmanagement');
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      dispatch(posCreators.callPosFoodMenu(checkIsEmpty, resetReload));
    }
  }, []);

  const resetReload = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    form.resetFields();
    dispatch(posCreators.callPosFoodMenu(checkIsEmpty, resetReload));
  };

  const checkIsEmpty = (menu: []) => {
    const isEmpty = menu.filter(({ menuSKUId }) => menuSKUId === '' || menuSKUId === null);
    if (isEmpty.length === 0) {
      setFormInvalid(false);
    } else {
      setFormInvalid(true);
    }
  };

  const toPath = (path: string) => {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push(path);
  };

  const trimFieldValue = (fieldName: string) => {
    const value = form.getFieldValue(fieldName);
    if (value) {
      form.setFieldsValue({
        [fieldName]: value.trim()
      });
      form.validateFields([fieldName]);
    }
  };

  const checkFormInvalid = () => {
    let invalid = false;
    const values = form.getFieldsValue();
    for (const key in values) {
      if (values[key] === undefined || values[key] === '' || MenuValidator.menuSKUId.isError(values[key])) {
        invalid = true;
        break;
      }
    }
    setFormInvalid(invalid);
  };

  const onFinish = (buttonFlag: string, afterStep1Save?: any, partialUpdate?: any) => {
    const error = form.getFieldsError();
    const errorFieldName = error.find((e: any) => e.errors[0]?.props?.id === 'main.form.text.valid');
    if (errorFieldName) {
      dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
      form.scrollToField(errorFieldName.name[0], { behavior: 'smooth' });
    } else {
      const newSkuList = foodMenuData.map((value: any, i: number) => {
        return { menuId: value.menuId, menuSKUId: form.getFieldValue(`menuSKUId-${i}`) };
      });
      const shopId = shopData?.shopId;
      const body = { menus: newSkuList, shopId, buttonFlag };
      dispatch(httpCreators.request({
        id: POS_REQUEST_ID_LIST.PATCH_POS_MENUS,
        sagaHandler: posSagas.patchPosMenusHandler as any,
        callbackParams: { afterStep1Save, partialUpdate, toPath },
        service: PosService.patchPosMenus,
        serviceParams: body
      }));
    }
  };

  const cancelPos = () => {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      modalImageId: 'cancelPos-alert-img',
      modalTitle: 'main.posManagement.posActivate.popup.cancelPos.header',
      modalTitleId: 'cancelPos-header-text',
      modalContent: 'main.posManagement.posActivate.popup.cancelPos.content',
      modalContentId: 'cancelPos-content-text',
      onOkText: 'main.posManagement.posActivate.popup.cancelPos.ok',
      onOkTextId: 'cancelPos-ok-text',
      onCancelText: 'main.posManagement.posActivate.popup.cancelPos.cancel',
      onCancelTextId: 'cancelPos-cancel-text',
      onConfirm: () => {
        dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
        dispatch(httpCreators.request({
          id: POS_REQUEST_ID_LIST.PATCH_CANCEL_POS,
          sagaHandler: posSagas.patchCancelPosHandler as any,
          service: PosService.patchCancelPos,
          serviceParams: { shopId: shopData.shopId },
          callbackParams: {
            alertCancelPosSuccess: () => dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_CANCEL_POS_SUCCESS, true)),
            alertCancelPosFail: () => dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_CANCEL_POS_FAIL, true)),
            toPath
          },
        }));
        },
      type: MODAL_TYPE.CONFIRM_EDIT
    }));
  };

  const columns = [
    {
      width: metrics.tableHeader.width300,
      title: <FormattedMessage id={'main.posManagement.posActivate.step1.foodmenu.landing.table.name'} />,
      className: 'menu-name-header',
      dataIndex: 'menuName',
      render: (value: string, all: any, index: number) => {
        const indexId = `id-name-${index}`;
        return <RBHBox className={'box-menu-name'} style={{ width: metrics.tableHeader.width300 }} id={indexId}>
          <RBHBox className={'menu-image-content'} style={styles.imageBox}>
            <RBHImage id='image_upload' name='image_upload' style={styles.image} src={all.menuPhoto || ''}
              onError={(e: any) => e.target.src = Images.menudefault} />
          </RBHBox>
          <RBHBox style={styles.menuNameBox}>
            <RBHBox className={'menu-name-text'} style={styles.menuNameBox.menuNameText}>
              {value}
            </RBHBox>
            <RBHBox id={'menu-description-text'} style={styles.menuNameBox.menuDescriptionText}>
              {all.menuDescription}
            </RBHBox>
          </RBHBox>
        </RBHBox>;
      }
    },
    {
      width: metrics.tableHeader.width100,
      title: <FormattedMessage id={'main.foodmenu.landing.table.price'} />,
      dataIndex: 'menuPrice',
      align: 'right',
      render: (value: any, all: any, index: number) => {
        const indexId = `id-price-${index}`;
        return (
          <RBHBox style={{
            width: metrics.tableHeader.width80,
            fontFamily: Fonts.type.KanitRegular,
            fontSize: Fonts.size.text14
          }} id={indexId}>
            {value}
          </RBHBox>
        );
      }
    },
    {
      width: metrics.tableHeader.width100,
      title: <FormattedMessage id={'main.foodmenu.landing.table.category'} />,
      dataIndex: 'menuCategory.menuCategoryName',
      render: (value: any, all: any, index: number) => {
        const indexId = `id-catagory-${index}`;
        return (
          <RBHBox style={{
            width: metrics.tableHeader.width100,
            fontFamily: Fonts.type.KanitRegular,
            fontSize: Fonts.size.text14,
          }} id={indexId}>
            {all.menuCategory.menuCategoryName}
          </RBHBox>
        );
      }
    },
    {
      width: metrics.tableHeader.width300,
      title: <RBHBox>
        <FormattedMessage id={'main.posManagement.posActivate.table.menuSku'} />
        <RBHImage style={styles.asterisk} src={Images.asterisk}
          data-testid={'pos-asterisk-icon'} id={'pos-asterisk-icon'} />
      </RBHBox>,
      render: (value: any, all: any, index: number) => {
        const menuSKUId = `menuSKUId-${index}`;
        // validate initialValue
        if (!!value.menuSKUId && MenuValidator.menuSKUId.isError(value.menuSKUId)) {
          form.validateFields([menuSKUId]);
          form.scrollToField(menuSKUId, { behavior: 'smooth' });
        }
        return (
          <RBHBox style={{ width: metrics.tableHeader.width300 }}>
            <Form className={'customWidth'} size='large' style={styleText.formText} form={form} onFieldsChange={checkFormInvalid} >
              <Form.Item colon={false} name={menuSKUId} validateTrigger={['onChange', 'onBlur']}
                initialValue={value.menuSKUId ? value.menuSKUId : undefined}
                rules={[
                  { pattern: MenuValidator.menuSKUId.regexPattern, message: <FormattedMessage id={'main.form.text.valid'} /> },
                  { required: true, message: <FormattedMessage id={'main.form.required2'} /> },
                ]}
              >
                <RBHTextInput id={menuSKUId} data-testid={menuSKUId} placeholder={'main.foodmenu.addmenu.menuSKUId.placeholder'}
                  onBlur={() => trimFieldValue(menuSKUId)} maxLength={MenuValidator.menuSKUId.maxLength} autoComplete='off' />
              </Form.Item>
            </Form>
          </RBHBox>
        );
      },
    }
  ];

  setTimeout(() => {
    if (alertSuccess) {
      dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_SUCCESS, false));
    }
  }, 3000);

  const handleSuccessClose = () => {
    dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_SUCCESS, false));
  };

  const isAlert = () => {
    if (alertSuccess) {
      return (
        <RBHBox id={'posActivate-alert-step1-success'} data-testid={'posActivate-alert-step1-success'}>
          <RBHAlert type={'success'} text={'main.posManagement.posActivate.step1.alert.success'}
            afterClose={handleSuccessClose} /><br />
        </RBHBox>
      );
    }
  };

  const BreadcrumbRender = () => {
    return (
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a data-testid={'posmanagement-tohomepage-breadcrumb'}
              id={'posmanagement-tohomepage-breadcrumb'} style={styleText.breadCrumbItemLink}
              onClick={() => dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true,
                onSaveAndLeave: () => {
                  onFinish(BUTTON_FLAG.SAVE_ONLY,
                    () => toPath('/main'),
                    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false })));
                },
                onLeaveOnly: () => { toPath('/main'); },
                type: MODAL_TYPE.POS_LEAVE_STEP_CONFIRM
              }))}>
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a data-testid={'branchmanagement-breadcrumb'}
              id={'branchmanagement-breadcrumb'} style={styleText.breadCrumbItemLink}
              onClick={() => dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true,
                onSaveAndLeave: () => {
                  onFinish(BUTTON_FLAG.SAVE_ONLY,
                    () => toPath('/main/branchmanagement'),
                    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false })));
                },
                onLeaveOnly: () => { toPath('/main/branchmanagement'); },
                type: MODAL_TYPE.POS_LEAVE_STEP_CONFIRM
              }))}>
              <FormattedMessage id={'main.branchmanagement'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a data-testid={'posManagement-breadcrumb'}
              id={'posManagement-breadcrumb'} style={styleText.breadCrumbItemLink}
              onClick={() => dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true,
                onSaveAndLeave: () => {
                  onFinish(BUTTON_FLAG.SAVE_ONLY,
                    () => toPath('/main/posmanagement'),
                    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false })));
                },
                onLeaveOnly: () => { toPath('/main/posmanagement'); },
                type: MODAL_TYPE.POS_LEAVE_STEP_CONFIRM
              }))}>
              <FormattedMessage id={'main.posManagement.landing.posManagement'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span data-testid={'posActivate-breadcrumb'}
              id={'posActivate-breadcrumb'} style={styleText.breadCrumbItem}>
              <FormattedMessage id={'main.posManagement.breadcrumb.activate.pos'} />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </RBHBox>
    );
  };

  const headerRender = () => {
    return (
      <RBHBox style={styles.header}>
        <RBHText data-testid={'posActivate-step1-header'} id={'posActivate-step1-header'}
          style={styleText.headerText} text={'main.posManagement.breadcrumb.activate.pos'} />
        <RBHText data-testid={'cancel-posActivate-step1'} id={'cancel-posActivate-step1'}
          style={styles.regularPurple14under} text={'main.posManagement.posActivate.cancelActivatePos'}
          onClick={cancelPos} />
      </RBHBox>
    );
  };

  const posStepText = (step: number) => {
    if (step === 1) {
      return (
        <RBHBox>
          <RBHText data-testid={'posActivate-step1-1'} id={'posActivate-step1-1'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step1.1'} />
          <RBHText data-testid={'posActivate-step1-2'} id={'posActivate-step1-2'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step1.2'} />
        </RBHBox>
      );
    } else if (step === 2) {
      return (
        <RBHBox>
          <RBHText data-testid={'posActivate-step2-1'} id={'posActivate-step2-1'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step2'} />
        </RBHBox>
      );
    } else if (step === 3) {
      return (
        <RBHBox>
          <RBHText data-testid={'posActivate-step3-1'} id={'posActivate-step3-1'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step3.1'} />
          <RBHText data-testid={'posActivate-step3-2'} id={'posActivate-step3-2'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step3.2'} />
        </RBHBox>
      );
    } else if (step === 4) {
      return (
        <RBHBox>
          <RBHText data-testid={'posActivate-step4'} id={'posActivate-step4'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step4'} />
        </RBHBox>
      );
    }
  };

  const stepRender = () => {
    const { Step } = Steps;
    return (
      <RBHSteps current={0} type={'default'} className={'posStep'} style={styles.paddingBottom20}>
        <Step style={styles.regular16fakeBlack} title={posStepText(1)} />
        <Step style={styles.regular16fakeBlack} title={posStepText(2)} />
        <Step style={styles.regular16fakeBlack} title={posStepText(3)} />
        <Step style={styles.regular16fakeBlack} title={posStepText(4)} />
      </RBHSteps>
    );
  };

  const shopNameAndDescRender = () => {
    return (
      <RBHBox>
        <RBHBox style={{ display: 'flex' }}>
          <RBHText data-testid={'posActivate-shopNameLabel'} id={'posActivate-shopNameLabel'}
            style={styles.medium16fakeBlackTop} text={'main.posManagement.posActivate.shopNameLabel'} />&nbsp;
          <RBHText style={styles.regular16DarkGray}>{shopData?.shopName}</RBHText>
        </RBHBox>
        <RBHBox style={styles.line} />
        <RBHText data-testid={'posActivate-menuSkuLabel'} id={'posActivate-menuSkuLabel'}
          style={styles.medium16fakeBlackBottom} text={'main.posManagement.posActivate.menuSkuLabel'} />
        <RBHText data-testid={'posActivate-menuSkuDesc'} id={'posActivate-menuSkuDesc'}
          style={styles.regular14DarkGray} text={'main.posManagement.posActivate.menuSkuDesc'} />
      </RBHBox>
    );
  };

  const tableRender = () => {
    return (
      <RBHBox style={styles.defaultContent}>
        {shopNameAndDescRender()}
        <RBHTable
          locale={{
            emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<span> <FormattedMessage id={'main.table.notFound'} /> </span>} />
          }}
          rowKey={'menuId'}
          columns={columns}
          dataSource={foodMenuData}
          scroll={{ y: 388 }}
          pagination={false} />
      </RBHBox>
    );
  };

  const buttonsRender = () => {
    return (
      <RBHBox style={styles.boxButtonStep1}>
        <Space size={'middle'}>
          <RBHButton
            id={'posActivate-buttonSaveOnly'}
            style={styles.buttonFromCancelGradient}
            type='primary'
            htmlType='button'
            onClick={() => {
              onFinish(BUTTON_FLAG.SAVE_ONLY,
                () => {
                  dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_SUCCESS, true));
                  resetReload();
                });
            }}
            text={'main.posManagement.posActivate.buttonSaveOnly'}
            data-testid={'posActivate-buttonSaveOnly'} />
          <RBHButton
            id={'posActivate-buttonSaveAndNext'}
            style={styles.buttonFromConfirmGradient}
            type='primary'
            htmlType='button'
            onClick={() => {
              onFinish(BUTTON_FLAG.SAVE_AND_NEXT_STEP,
                () => {
                  toPath('/main/posmanagement/step2');
                },
                () => {
                  dispatch(posCreators.setPosState(POS_STATE_KEY.POS_FOOD_MENU, []));
                  setTimeout(() => {
                    resetReload();
                  }, 50);
                });
            }}
            disabled={formInvalid}
            text={'main.posManagement.posActivate.buttonSaveAndNext'}
            data-testid={'posActivate-buttonSaveAndNext'} />
        </Space>
      </RBHBox>
    );
  };

  return (
    <RBHBox>
      {isAlert()}
      {BreadcrumbRender()}
      <RBHBox>
        {headerRender()}
        {stepRender()}
        {loading ? null :
          <RBHBox>
            {tableRender()}
            {buttonsRender()}
          </RBHBox>
        }
      </RBHBox>
    </RBHBox>
  );
};

type Props = {};
